import { Box, Divider, Typography, useTheme } from "@material-ui/core";

const CardHeader: React.FC<{ title: string; rightTitle?: string | null; pb?: number }> = ({ title, rightTitle, pb = 2 }) => {
	const { palette } = useTheme();

	return (
		<>
			<Box display="flex" width="100%" justifyContent="space-between" p={2} px={4}>
				<Typography
					align="left"
					variant="h5"
					color="textSecondary"
					style={{ fontSize: "18px", fontWeight: 600, marginRight: "5px" }}
				>
					{title}
				</Typography>
				{rightTitle && (
					<Typography
						align="left"
						variant="h5"
						color="textSecondary"
						style={{ fontSize: "18px", fontWeight: 600, marginRight: "5px" }}
					>
						{rightTitle}
					</Typography>
				)}
			</Box>
			<Box justifyContent="space-between" width="100%" display="flex" alignItems="center" pb={pb}>
				<Divider style={{ flexGrow: 1, backgroundColor: palette.tableDivider.main }} />
			</Box>
		</>
	);
};

export default CardHeader;
